export const monitoredHomePageSections = [
  'user-recommendations',
  'social-apps',
];
